import './ModalContainer.css';

import React, { type FC } from 'react';

interface ModalContainerInterface {
  disableClose: boolean
  show: boolean
  onClick?: () => void
}

export const ModalContainer: FC<ModalContainerInterface> = ({ children, disableClose, show, onClick }) => {
  if (!show) { return null; }

  const closeIcon = disableClose ? null : <i className="fal fa-times modal-close-icon" onClick={onClick}></i>;

  return (
    <div className="modal-container">
      <div className="modal-container-content">
        { closeIcon }
        { children }
      </div>
    </div>
  );
};
